console.log("collection.js loaded")
// debugger;
addEventListener('DOMContentLoaded', handleDOMContentLoaded);

let emptyProductFetchResponse = false
let mergedProductsArray = []

async function handleDOMContentLoaded() {

   console.log("DOMContentLoaded");

      // Create an intersection observer
   const observer = new IntersectionObserver(entries => {
      // Loop through the entries
      for (const entry of entries) {
      // Check if the entry is intersecting
      if (!entry.isIntersecting) {
         // If not, pause the video
         entry.target.pause();
         entry.target.classList.add("paused");
      } else {
         // If it is, play the video
         entry.target.play();
         entry.target.classList.remove("paused");
      }
      }
   });
   
   // Get all the video elements on the page
   const videos = document.querySelectorAll('video');
   
   // Observe each video
   videos.forEach(video => {
      observer.observe(video);
      video.play()
   });
   
   
   if (window.location.pathname.startsWith('/search') && $('.c-product-item').length === 0) {
      // debugger
      document.getElementById('FacetFiltersForm').style.display = 'none';
    }


   let url = new URL(window.location.href);

   const initialProductCards = document.querySelectorAll(".c-product-item");

   initialProductCards.forEach((card) => {
      productsArray.push({ handle: card.getAttribute('data-product-handle'), id: card.getAttribute('data-product-id') });
      productIdsArray.push(Number(card.getAttribute('data-product-id')))
      productIdsArray = new Set(productIdsArray)
      productIdsArray = Array.from(productIdsArray)
      productsArrayPosition++
   })

   console.log("productsArray at domcontentloaded:", productsArray)

   async function* fetchProducts() {
      let firstFetch = true;
      while((url && $('.c-product-item').length < 40 && $('.c-product-item').length % 40 !== 0) || (url && $('.c-product-item').length === 40 && firstFetch)) {
         // debugger;
         // if (productsArray.length === 0) {
            if (productsArray.length === productsArrayPosition) {
            const response = await fetchJsonFromShopify(Array.from(url.searchParams.entries()));
            if (firstFetch && response.length !== 0) {
               const loadMore = document.querySelector('.s-collection__pagination')
               loadMore.style.display = 'block'
            }
            firstFetch = false
         
            for(let product of response) {
               console.log("fetchProduct product", product)
               // debugger
               if (Object.keys(product).length === 0 && product.constructor === Object) {
                  yield product;
               } else {
                  return
               }
            }
         }
      }
   }
   // debugger;
   for await (let product of fetchProducts()) {
      // debugger;
      console.log("for await product", product, productsArray, productsArray.length, productsArrayPosition)
      productsArray.push(product)
      if (productsArray[productsArrayPosition].available === "true" && (!productIdsArray.includes(productsArray[productsArrayPosition].product_id)) ) {
         createProductItem(productsArray[productsArrayPosition])
      }
      productsArrayPosition++
      // if (($('.c-product-item').length <= 12) && (productsArray.length <= 12)) {
      //    debugger;
      //    const loadMore = document.querySelector('.s-collection__pagination')
      //    loadMore.style.display = 'none'
      //    break;
      // }
      if ($('.c-product-item').length % 40 === 0) {
         // debugger;
         const loadMore = document.querySelector('.s-collection__pagination')
         loadMore.style.display = 'block'
         break;
      }
   }
}
localStorage.setItem('shopify-page', '1');

jQuery( document ).ready( function( $ ) {


    const loadMoreSection = document.querySelector('.s-collection__pagination');
    if ((localStorage.getItem('shopify-page') == '1') && ($('.c-product-item').length < 40)) {
       console.log("on collection page load", localStorage.getItem('shopify-page'), $('.c-product-item').length)
      loadMoreSection?.style.setProperty("display", "none");
    } else {
      loadMoreSection?.style.setProperty("display", "block");
    }
 
 });